module.exports = __webpack_public_path__ + "static/20-87603192f8381ea94fbe1d91b0e4ab1f.jpg";